<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <ejs-tab ref="tabObj" heightAdjustMode="Auto" :selecting="disableSelecting">
        <div class="e-tab-header">
          <div>{{$t('Security.IPRangeSet')}}</div>
          <div>{{$t('Security.userIPSet')}}</div>
        </div>
        <div class="e-content">
          <div id="account_tab1" style="display: none">
            <IpRangePage ref="ipRangePage"></IpRangePage>
          </div>
          <div id="account_tab2" style="display: none">
            <AccountIpPage ref="accountIpPage"></AccountIpPage>
          </div>
        </div>
      </ejs-tab>
    </template>
  </BasicLayout>
</template>
<script>
  import BasicLayout from '../../layouts/BasicLayout';
  import IpRangePage from '../../components/security/clientManager/ipRangePage';
  import AccountIpPage from '../../components/security/clientManager/accountIpPage';


  export default {
    name: 'Client',
    components: {
      BasicLayout,
      IpRangePage,
      AccountIpPage
    },
    data() {
      return {
        left: { show: false, name: '' },
        middle: { show: false, name: '' },
        right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Security.clientRules')}` },
      }
    },
    methods: {
      disableSelecting(e) {
        if (e.isSwiped) {
          e.cancel = true;
        }
      }
    }
  }
</script>
